module.exports = __webpack_public_path__ + "static/vwtext-light-4c6cc52ee152a8cd77f340b42944c47b.woff2";